import { Component } from '@angular/core';

@Component({
  selector: 'app-card-chips',
  templateUrl: './card-chips.component.html',
  styleUrls: ['./card-chips.component.scss']
})
export class CardChipsComponent {

}
